import { Component, ElementRef, Input, ViewChild } from '@angular/core';

type variants = 'primary' | 'secondary' | 'outline' | 'ecommerce' | 'eoutline';

@Component({
    selector: 'komodo-button',
    templateUrl: './komodo-button.component.html',
    styleUrls: ['./komodo-button.component.scss'],
})
export class KomodoButtonComponent {

    @Input() label: string | null = null;
    @Input() variant: variants = 'primary';
    @Input() fullspace: boolean = false;

    @ViewChild('coreButton', {
        static: true,
        read: ElementRef<HTMLButtonElement>
    }) coreButton!: ElementRef<HTMLButtonElement>;

    constructor() {}

}
